
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  CharacterFeatureBase,
  CharacterSubrace,
  Character,
  Race, 
  Subrace,
} from "@dndModels";
import { DataType } from "@dndModels/Types";

/**
 * This represents a race with the options chosen for a character.
 */
export class CharacterRace extends CharacterFeatureSource {
  old_subrace: CharacterSubrace | null = null;
  source: Race | null = null;
  subrace_id = "";

  get data_type(): DataType {
    return "race";
  }

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      if (this.source_id === "" && obj.race_id) {
        this.source_id = obj.race_id;
      }
      if (this.char_feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          const fb = new CharacterFeatureBase(o);
          fb.source_id = this.source_id;
          fb.source_name = this.name;
          fb.source_type = "Race";
          // fb.root_id = this.source_id;
          // fb.root_name = this.name;
          // fb.root_type = "Race";
          this.char_feature_bases.push(fb);
        });
      }
      this.old_subrace = obj.subrace ? new CharacterSubrace(obj.subrace) : null;
      if (obj.subrace_id) {
        this.subrace_id = obj.subrace_id;
      } else if (this.old_subrace) {
        this.subrace_id = this.old_subrace.source_id;
      }
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      subrace_id: this.subrace_id
      // subrace: this.subrace?.toDBObj() ?? null
    };
  }

  get char_subrace(): CharacterSubrace | null {
    const sub_finder = this.sub_char_feature_sources.filter(o => o.source_type === "Subrace");

    if (sub_finder.length === 1) {
      return sub_finder[0] as CharacterSubrace;
    }
    return null;
  }

  get use_name(): string {
    const source_use_name = this.get_use_name();
    if (this.char_subrace && this.char_subrace.source) {
      if (this.char_subrace.name.includes(source_use_name)) {
        return this.char_subrace.name;
      } else {
        return this.char_subrace.name + " " + source_use_name;
      }
    } else if (this.source) {
      return source_use_name;
    }
    return "No Race";
  }

  get creature_type() {
    return this.source?.creature_type??"None";
  }

  connect_subrace = async (char: Character, 
    subrace: Subrace) => {
    const sub_finder = this.sub_char_feature_sources.filter(o => o.source_type === "Subrace");
    const subrace_cfb_finder = this.char_feature_bases.filter(o => 
      // (o.edition_id === "Any" || char.character_options.edition_id === "Any" || o.edition_id === char.character_options.edition_id) && 
      o.features.filter(o2 => o2.feature_type === "Subrace").length > 0);

    if (sub_finder.length === 1 && subrace_cfb_finder.length === 1) {
      const subrace_cf = subrace_cfb_finder[0].features.filter(o => o.feature_type === "Subrace")[0];
      const sub = sub_finder[0] as CharacterSubrace;
      // const ancestries: Ancestry[] = [];
      // ancestries.push({ true_id: char.race.true_id, source_id: char.race.source_id, parent_id: "", type: "race", name: char.race.use_name });
      await sub.copy_source({ char, feature_source: subrace, parent_cf: subrace_cf });
    }
  }

  clone(drop_ids = false): CharacterRace {
    const clone = new CharacterRace();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterRace, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    // this.subrace = copyMe.subrace ? copyMe.subrace.clone(drop_ids) : null;
    this.source = copyMe.source;
    this.subrace_id = copyMe.subrace_id;
  }
}